// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1wzHf","modalFooterButton":"ModalNotes_modalFooterButton__3Xl3T"};